export enum FreeTextCategory {
    Inclusion = 'Inclusion',
    Bespoke = 'Bespoke',
    Engagement = 'Engagement',
}
